<div class="create">
  <div>
    <img src="/assets/imgs/artistpainting.webp" />
  </div>
  <div>
    <h1 class="x-small" [innerHTML]="'landing.create.title' | translate"></h1>
    <p class="mb-4">{{ 'landing.create.subtitle' | translate }}</p>
    <div>
      <app-button class="w-full xl:w-auto" customIconSrc="/assets/icons/magic-wand.svg" size="x-large" [shadow]="false" [routerLink]="projectLink" fragment="top" [label]="'landing.create.cta_create' | translate"></app-button>
    </div>
  </div>
</div>
